import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { lanekassenTheme, ScopedCssBaseline, ThemeProvider } from '@lanekassen/ui';
import { Popup } from './popup';
import { InitPopup } from '../dto/InitPopup';

function App(props: InitPopup) {
  return (
    <ThemeProvider theme={lanekassenTheme} defaultMode="light" storageManager={null}>
      <ScopedCssBaseline
        sx={(theme) => ({
          // Denne skal settes av ScopedCssBaseline,
          // men i AFL.Web så blir den overstyrt av sidens CSS, derfor må vi overstyre den tilbake
          '& .lk-link': {
            ...theme.typography['body-l'],
          },
        })}
      >
        <Popup {...props} />
      </ScopedCssBaseline>
    </ThemeProvider>
  );
}

export function mountPopup(props: InitPopup): void {
  const root = document.createElement('div');
  document.body.insertBefore(root, document.body.firstElementChild);

  createRoot(root).render(
    <StrictMode>
      <App {...props} />
    </StrictMode>,
  );
}
